var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 5.57812L9.40625 2.95312L10.2812 2.07813C10.5208 1.83854 10.8152 1.71875 11.1644 1.71875C11.5135 1.71875 11.8077 1.83854 12.0469 2.07813L12.9219 2.95312C13.1615 3.19271 13.2865 3.48187 13.2969 3.82062C13.3073 4.15937 13.1927 4.44833 12.9531 4.6875L12.0625 5.57812ZM11.1562 6.5L4.53125 13.125H1.875V10.4688L8.5 3.84375L11.1562 6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.0deda9afab73a4562f9b9e37252c3fb6.svg";
export { ForwardRef as ReactComponent };